import axios from "axios";
import {API_URL, TOKEN} from "@/config/constants.config";
import Cookies from "js-cookie";

export default () => {
    axios.defaults.baseURL = API_URL
    axios.interceptors.request.use((config) => {
        let accessToken = Cookies.get(TOKEN.BOUVET) ?? null
        if (accessToken) {
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        }
        return config
    }, (error) => {
        return Promise.reject(error)
    })

    axios.interceptors.request.use((response) => {
        return Promise.resolve(response);
    }, (error) => {
        return Promise.reject(error);
    })
}